/*
 * "ContactData" : {
 *   "type" : "object",
 *   "properties" : {
 *     "mobileNumber" : {
 *       "description" : "Mobile Telefonnummer",
 *       "type" : "string"
 *     },
 *     "phoneNumber" : {
 *       "description" : "Festnetz Telefonnummer",
 *       "type" : "string"
 *     }
 *   }
 * },
 */

export class ContactData {
  constructor(
    public mobile: string,
    public landline: string,
  ) { }

  public static fromJSON(json: {
    mobileNumber: string,
    phoneNumber: string,
  }): ContactData {
    if (!json) {
      throw new Error('ContactData JSON should not be undefined');
    }

    return new ContactData(
      json.mobileNumber,
      json.phoneNumber,
    );
  }
}
